import React from "react";

export const FooterLink = () => {

    return (
            <div className={'footer-link-wrap'}>
                <nav className={'footer-nav'}>
                    <a className={'nav-link'} href={'/#hero'}>О нас</a>
                    <a className={'nav-link'} href={'/#party'}>Наши вечеринки</a>
                    <a className={'nav-link'} href={'/#gallery'}>Галерея</a>
                    <a className={'nav-link'} href={'/#photo-zone'}>Фотозоны</a>
                    <a className={'nav-link'} href={'/#reviews'}>Отзывы</a>
                    <a className={'nav-link'} href={'/#order'}>Заказ праздника</a>
                </nav>
            </div>

    )
}